export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/arrow-down-twisted.5a6836ac.svg","height":37,"width":42,"blurWidth":0,"blurHeight":0};